import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Container,
  Link,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { requestPasswordReset } from '../services/api';

function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [resetUrl, setResetUrl] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    setMessage('');
    setResetUrl('');

    try {
      const response = await requestPasswordReset({ email });
      setMessage(response.data.message || t('auth.forgotPasswordSent'));
      if (response.data.resetUrl) {
        setResetUrl(response.data.resetUrl);
      }
    } catch (requestError) {
      setError(requestError.response?.data?.error || t('auth.forgotPasswordFailed'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          {t('auth.forgotPasswordTitle')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {t('auth.forgotPasswordSubtitle')}
        </Typography>
        {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}
        {message ? <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert> : null}
        {resetUrl ? (
          <Alert severity="info" sx={{ mb: 2 }}>
            {t('auth.resetUrlDevHint')}{' '}
            <Link href={resetUrl} target="_blank" rel="noopener noreferrer">
              {resetUrl}
            </Link>
          </Alert>
        ) : null}
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            label={t('auth.email')}
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{ mt: 3 }}
            disabled={submitting}
          >
            {t('auth.sendResetLink')}
          </Button>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Link component={RouterLink} to="/login" underline="hover">
            {t('auth.backToSignIn')}
          </Link>
        </Box>
      </Paper>
    </Container>
  );
}

export default ForgotPassword;
